module.exports = __webpack_public_path__ + "static/media/VaderPay_QR.f838cc49.svg";